import { useFormContext } from 'react-hook-form';
import { Grid } from '@mui/material';
import WSTextField from '../../../Components/TextBox/WSTextBox';
import WSDateField from '../../../Components/DateField/WSDateField';
import WSSelectField from '../../../Components/Select/WSSelect';
import WSFileUpload from '../../../Components/FileUpload/WSFileUpload';

const genderOptions = [{label:"Male",value:"male"},{label:"Female",value:"female"},{label:"Other",value:"other"}];

const maritalOptions = [{label:"Single", value:"single"},{label:"Married", value:"married"},{label:"Divorced", value:"divorced"}];

const religions = [
      { label: "Islam", value: "Islam" },
      { label: "Hinduism", value: "Hinduism" },
      { label: "Christianity", value: "Christianity" },
      { label: "Sikhism", value: "Sikhism" },
      { label: "Buddhism", value: "Buddhism" },
      { label: "Jainism", value: "Jainism" },
      { label: "Other", value: "Other" }
    ]


export const Step1Personal = () => {
  const { control } = useFormContext();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
          <WSTextField id="fname" label={"First Name"} control={control} name='fname'/>
      </Grid>
      <Grid item xs={12} sm={6}>
        <WSTextField id="lname" label={"Last Name"} control={control} name='lname'/>
      </Grid>
      <Grid item xs={12} sm={6}>
        <WSSelectField id="gender" label="Gender" name="gender" control={control} options={genderOptions}/>
      </Grid>
      <Grid item xs={12} sm={6}>
          <WSDateField id="blood" label={"DOB"} control={control} name='dob' rules={{required:true}}/>
      </Grid>
      <Grid item xs={12} sm={6}>
        <WSSelectField id="maritalStatus" label="Marital Status" name="maritalStatus" control={control} options={maritalOptions}/>
      </Grid>
      <Grid item xs={12} sm={6}>
        <WSTextField id="blood" label={"Blood Group"} control={control} name='bloodGroup' />
      </Grid>
      <Grid item xs={12} sm={6}>
          <WSTextField id="nationality" label={"Nationality"} control={control} name='nationality'/>
      </Grid>

      <Grid item xs={12} sm={6}>
          <WSTextField id="empCode" label={"Employee Code"} control={control} name='empCode'/>
      </Grid>
      {/* <Grid item xs={12} sm={6}>
  <WSSelectField
    id="religion"
    label="Religion"
    name="religion"
    control={control}
    options={religions}
  />
</Grid> */}

      {/* <Grid item xs={12}>
              <WSFileUpload
              id="profilePhoto"
                name="profilePhoto"
                label="Upload Employee Photo"
                acceptFileTypes='image/*'
                image
                control={control}
              />
            </Grid> */}
    </Grid>
  );
};
